export interface CronSuccessRateStats {
  percent: number
  successful: number
  total: number
  successfulLabel: string
  totalLabel: string
}

export function buildCronSuccessRateStats(
  successful: number | null | undefined,
  total: number | null | undefined,
  percent?: number | null,
): CronSuccessRateStats {
  const safeSuccessful = Math.max(0, Number(successful) || 0)
  const safeTotal = Math.max(0, Number(total) || 0)
  const calculatedPercent = safeTotal > 0
    ? Math.round((safeSuccessful / safeTotal) * 100)
    : 0
  const resolvedPercent = percent == null || !Number.isFinite(Number(percent))
    ? calculatedPercent
    : Math.max(0, Math.min(100, Math.round(Number(percent))))

  return {
    percent: resolvedPercent,
    successful: safeSuccessful,
    total: safeTotal,
    successfulLabel: safeSuccessful.toLocaleString('en-US'),
    totalLabel: safeTotal.toLocaleString('en-US'),
  }
}
